/* eslint no-unused-vars: 0 */
import React, { useState, useCallback } from 'react';
import { MdAddCircle } from 'react-icons/md';
import { FaPencilAlt, FaTrash } from 'react-icons/fa';
import { AiFillProfile, GiConsoleController } from 'react-icons/all';
import { Grid } from '~/components';
import { useForm } from '~/hooks';
import { useSectionDetail } from '~/hooks/useSection';
import sectionTypes from '../sectionTypes';
import { AiOutlineSearch } from 'react-icons/ai';
import { useSectionLoader, useAutoSave } from '../../hooks';
import { FormGroup, FormSelect, TextArea } from '~/components/form';
import { MdClose } from 'react-icons/md';
import { FileDrop } from '~/components';
import { DocumentType } from '~/api/document';
import { useAutoSaveMultiple} from '../../hooks';


const initialState = {
    sectionId: 0,
    sectionDetails: [],
    selectedDeed: {},
    modalOpen: false,
    editDeed: false,
    lienOrderOptions: [
        { label: 'First', value: 1 },
        { label: 'Second', value: 2 },
        { label: 'Third', value: 3 },
        { label: 'Fourth', value: 4 }
    ],
    lienOrder: null,
};


const loadData = async (values) => {
    return {
        ...values,
        selectedDeed: {}
    };
};

const DeedsOfTrust = (props) => {

    const {
        titleOpinionId,
        readonly = false,
        sectionId,
        sectionDetails
    } = props;

    const {
        deleteDetail
    } = useSectionDetail(sectionTypes.DEED, sectionId, titleOpinionId);

    const { onLoad: loadSection } = useSectionLoader(sectionTypes.DEED, titleOpinionId);
    const onLoad = useCallback((values) => {
        return loadData(values)
            .then(v => loadSection(v));
    }, [titleOpinionId]);

    const {
        /** @type {FormState} */
        state,
        fieldActions
    } = useForm({
        /** @type {TaxesAndSpecialAssesmentsValues} */
        initialState: { ...initialState },
        onLoad,
        debug: true
    });

    const { saveField, saveDocument, deleteDocument } = useAutoSave(sectionTypes.DEED, titleOpinionId, state.values.selectedDeed, state.values.sectionId);
    const { saveMulitpleField } = useAutoSaveMultiple(sectionTypes.DEED, titleOpinionId, state.values.initialDefaultData, state.values.sectionId);

    const onBlur = (value, path, validator) => {
        saveField(value, path, state.values.selectedDeed, state.values.sectionId);
        return fieldActions.onBlur(value, path, validator);
    };

    const handleChange = (value, path) => {
        saveField(value, path, state.values.selectedDeed, state.values.sectionId);
        return fieldActions.onChange(value, path);
    };

    const handleChanges = (value, path) => {
        
        return fieldActions.onChange(value, path);
    };
    const removeSeconddeed = async () => {
        const data = {
            secgrantors:"",
            secgrantee:'',
            secdated:'',
            secrecordedOn:'',
            secbook:'',
            secpage:'',
            seccountyRegistry: '',
            mortgageClauseOtherSecondary: '',
            secsecuringAmountOf: ''  
             
        };
        
        await saveMulitpleField(data,titleOpinionId, state.values.initialDefaultData, state.values.sectionId);
       
      
        
    };
    const defaultState = {
        lienOrder: [],     
          
    };
    const removeDeedofTrust = async () => {
        const data = {
            lienOrder: defaultState.lienOrder,
            dotmortgators:'',
            dotbeneficiary:'',
            dottrustee:'',
            dotsecuringAmountOf:'',
            dotdated:'',
            dotrecordedOn:'',
            dotbook:'',
            dotpage:'',
            dotcountyRegistry:'',
            dotreRecordedOn:'',
            dotreBook:'',
            dotrePage:'',
            dotreCountyRegistry:'',
            dotassignedTo:'',
            dotassignedBook:'',
            dotassignedPage:'',
            dotassignedCountyRegistry:'',
                        
            
        };       
        await saveMulitpleField(data,titleOpinionId, state.values.initialDefaultData, state.values.sectionId);
       
    };

    const [deedCount, setDeedCount] = useState(1);
    const [deedOfTustCountExceeded, setDeedOfTustCountExceeded] = useState(false);

    const closeModal = async () => {
        handleChanges(undefined, "secgrantee");
        handleChanges(undefined, "secgrantors");
        handleChanges(undefined, "secdated");
        handleChanges(undefined, "secrecordedOn");
        handleChanges(undefined, "secbook");
        handleChanges(undefined, "secpage");
        handleChanges(undefined, "seccountyRegistry");
        handleChanges(undefined, "securingAmountOf");
        setDeedCount(deedCount - 1);
        await fieldActions.onChange({}, 'selectedDeed');
        await fieldActions.onChange(false, 'modalOpen');
    };

    const closeDeedTrustModal = async () => {

        handleChanges(undefined, "dotmortgators");
        handleChanges(undefined, "dotbeneficiary");
        handleChanges(undefined, "dottrustee");
        handleChanges(undefined, "dotsecuringAmountOf");
        handleChanges(undefined, "dotdated");
        handleChanges(undefined, "dotrecordedOn");
        handleChanges(undefined, "dotbook");
        handleChanges(undefined, "dotpage");
        handleChanges(undefined, "dotcountyRegistry");
        handleChanges(undefined, "dotreRecordedOn");
        handleChanges(undefined, "dotreBook");
        handleChanges(undefined, "dotrePage");
        handleChanges(undefined, "dotreCountyRegistry");
        handleChanges(undefined, "lienOrder");
        setDeedOfTustCountExceeded(false);
        setDeedOfTrustData([]);


        await fieldActions.onChange({}, 'selectedDeed');
        await fieldActions.onChange(false, 'modalOpen');
    };

    const addDeed = async () => {

        setDeedCount(deedCount + 1);
    };

    const addDeedOfTrust = async () => {
        setDeedOfTustCountExceeded(true);
    };



    const [deedOfTrustData, setDeedOfTrustData] = useState([]);
    const deleteDeed = id => deleteDetail(id);

    return (
        <>
            <div className="mb-5">
                <div>
                    <div className="z-10 flex items-center h-full text-xl font-semibold text-blue-60">
                        <div className="h-11 w-11 rounded-md flex items-center justify-center bg-blue-30"><AiFillProfile size="45%" /></div>
                        <div className="ml-2"> Deed Information </div>
                    </div>

                </div>
            </div>
            <div className="text-sm mb-2">Please note any information changes will overwrite any previously entered. Changes are saved automatically.</div>

            {/* <Deeds className='mt-8' details={sectionDetails} onEdit={editDeed} onDelete={deleteDeed} readonly={readonly} /> */}
            {/* {deedData} */}
            <header className='pt-2 pb-1 px-4 border-b flex items-center justify-between'>
                <p className='font-semibold'>{"Deed 1"}</p>
                {length === 1 && (
                    <button
                        variant="outline-danger"
                        className='rounded-full p-2 hover:bg-gray-150 focus:outline-none'
                        style={{ color: "red" }}
                        onClick={closeModal}
                    >
                        <MdClose />
                    </button>
                )}

            </header>
            <TextArea
                label='Grantor(s)'
                readOnly={readonly}
                autoComplete='no'
                groupClassName='col-span-12'
                inputClassName='w-full border-1 border-gray-200 rounded bg-gray-50'
                value={state.values.grantors}
                path='grantors'
                {...fieldActions}
                onBlur={onBlur}
            />
            <FormGroup
                label='Grantee(s)'
                readOnly={readonly}
                groupClassName='col-span-12'
                inputClassName='w-full border-1 border-gray-200 rounded bg-gray-50'
                value={state.values.grantee}
                path='grantee'
                {...fieldActions}
                onBlur={onBlur}
            />
            <div className="col-span-8 grid grid-cols-12 grid-flow-row gap-x-8 gap-y-4 text-sm mb-4">
                <FormGroup
                    label='Purchase Price'
                    readOnly={readonly}
                    type='currency'
                    groupClassName='col-span-3'
                    inputClassName='w-full border-1 border-gray-200 rounded bg-gray-50'
                    value={state.values.securingAmountOf}
                    path='securingAmountOf'
                    {...fieldActions}
                    onBlur={onBlur}
                />
                <FormGroup
                    label='Dated'
                    type='date-picker'
                    readOnly={readonly}
                    dateFormat="MM/dd/yyyy"
                    groupClassName='col-span-3'
                    inputClassName='w-full border-1 border-gray-200 rounded bg-gray-50'
                    datePickerClasses="w-full"
                    value={state.values.dated}
                    path='dated'
                    {...fieldActions}
                    onChange={handleChange}
                />
                <FormGroup
                    label='Recorded On'
                    type='date-picker'
                    readOnly={readonly}
                    dateFormat="MM/dd/yyyy   h:mm aa"
                    showTimeInput
                    timeInputLabel="Time:"
                    datePickerClasses="w-full"
                    groupClassName='col-span-3'
                    inputClassName='w-full border-1 border-gray-200 rounded bg-gray-50'
                    value={state.values.recordedOn}
                    path='recordedOn'
                    {...fieldActions}
                    onChange={handleChange}
                />
                <div className='col-span-3'></div>
                <FormGroup
                    label='Book'
                    readOnly={readonly}
                    required
                    groupClassName='col-span-3'
                    inputClassName='w-full border-1 border-gray-200 rounded bg-gray-50'
                    value={state.values.book}
                    path='book'
                    {...fieldActions}
                    onChange={handleChange}
                />
                <FormGroup
                    label='Page'
                    readOnly={readonly}
                    required
                    groupClassName='col-span-3'
                    inputClassName='w-full border-1 border-gray-200 rounded bg-gray-50'
                    value={state.values.page}
                    path='page'
                    {...fieldActions}
                    onChange={handleChange}

                />
                <FormGroup
                    label='County Registry'
                    readOnly={readonly}
                    required
                    groupClassName='col-span-3'
                    inputClassName='w-full border-1 border-gray-200 rounded bg-gray-50'
                    value={state.values.countyRegistry}
                    path='countyRegistry'
                    {...fieldActions}
                    onChange={handleChange}
                />
            </div>
            <div className='col-span-12 border-b py-2' />
            <FileDrop
                files={state.values.documents?.filter(d => d.type === DocumentType.DEED && !d.isDeleted)}
                className='w-full h-20'
                groupClassName='col-span-12'
                multiple
                readOnly={readonly}
                onChange={files => {
                    const _files = files
                        .map(f => {
                            return {
                                ...f,
                                type: DocumentType.DEED,
                                uploaded: f.uploaded == undefined ? false : f.uploaded,
                                isDeleted: f.isDeleted != undefined ? f.isDeleted : false
                            };
                        });
                    _files.map(d => {
                        if (!d.uploaded) {
                            saveDocument(d, d.type, state.values.sectionId);
                        }
                    });
                    handleChange(_files, 'documents');
                }}
                onRemove={(file) => {
                    const files = state.values.documents.filter(d => d.id === file.id);
                    deleteDocument(file.id, state.values.sectionId);
                    fieldActions.onChange(files, 'documents');
                }}
                heading='Upload Copy of Deed'
            />
            {(deedCount > 1 || state.values.secgrantors) && (
                <>
                    <header className='pt-2 pb-1 px-4 border-b flex items-center justify-between'>
                        <p className='font-semibold'>{"Deed 2"}</p>

                        <button
                            variant="outline-danger"
                            className='rounded-full p-2 hover:bg-gray-150 focus:outline-none'
                            style={{ color: "red" }}
                            onClick={function() { removeSeconddeed(); closeModal(); }}
                        >
                            <MdClose />
                        </button>
                    </header>
                    <TextArea
                        label='Grantor(s)'
                        readOnly={readonly}
                        autoComplete='no'
                        groupClassName='col-span-12'
                        inputClassName='w-full border-1 border-gray-200 rounded bg-gray-50'
                        value={state.values.secgrantors}
                        path='secgrantors'
                        {...fieldActions}
                        onBlur={onBlur}
                    />
                    <FormGroup
                        label='Grantee(s)'
                        readOnly={readonly}
                        groupClassName='col-span-12'
                        inputClassName='w-full border-1 border-gray-200 rounded bg-gray-50'
                        value={state.values.secgrantee}
                        path='secgrantee'
                        {...fieldActions}
                        onBlur={onBlur}
                    />
                    <div className="col-span-8 grid grid-cols-12 grid-flow-row gap-x-8 gap-y-4 text-sm mb-4">
                        <FormGroup
                            label='Purchase Price'
                            readOnly={readonly}
                            type='currency'
                            groupClassName='col-span-3'
                            inputClassName='w-full border-1 border-gray-200 rounded bg-gray-50'
                            value={state.values.secsecuringAmountOf}
                            path='secsecuringAmountOf'
                            {...fieldActions}
                            onBlur={onBlur}
                        />
                        <FormGroup
                            label='Dated'
                            type='date-picker'
                            readOnly={readonly}
                            dateFormat="MM/dd/yyyy"
                            groupClassName='col-span-3'
                            inputClassName='w-full border-1 border-gray-200 rounded bg-gray-50'
                            datePickerClasses="w-full"
                            value={state.values.secdated}
                            path='secdated'
                            {...fieldActions}
                            onChange={handleChange}
                        />
                        <FormGroup
                            label='Recorded On'
                            type='date-picker'
                            readOnly={readonly}
                            dateFormat="MM/dd/yyyy   h:mm aa"
                            showTimeInput
                            timeInputLabel="Time:"
                            datePickerClasses="w-full"
                            groupClassName='col-span-3'
                            inputClassName='w-full border-1 border-gray-200 rounded bg-gray-50'
                            value={state.values.secrecordedOn}
                            path='secrecordedOn'
                            {...fieldActions}
                            onChange={handleChange}
                        />
                        <div className='col-span-3'></div>
                        <FormGroup
                            label='Book'
                            readOnly={readonly}
                            required
                            groupClassName='col-span-3'
                            inputClassName='w-full border-1 border-gray-200 rounded bg-gray-50'
                            value={state.values.secbook}
                            path='secbook'
                            {...fieldActions}
                            onChange={handleChange}
                        />
                        <FormGroup
                            label='Page'
                            readOnly={readonly}
                            required
                            groupClassName='col-span-3'
                            inputClassName='w-full border-1 border-gray-200 rounded bg-gray-50'
                            value={state.values.secpage}
                            path='secpage'
                            {...fieldActions}
                            onChange={handleChange}

                        />
                        <FormGroup
                            label='County Registry'
                            readOnly={readonly}
                            required
                            groupClassName='col-span-3'
                            inputClassName='w-full border-1 border-gray-200 rounded bg-gray-50'
                            value={state.values.seccountyRegistry}
                            path='seccountyRegistry'
                            {...fieldActions}
                            onChange={handleChange}
                        />
                    </div>
                    <div className='col-span-12 border-b py-2' />
                    <FileDrop
                        files={state.values.documents?.filter(d => d.type === DocumentType.COPYOFDEED && !d.isDeleted)}
                        className='w-full h-20'
                        groupClassName='col-span-12'
                        multiple
                        readOnly={readonly}
                        onChange={files => {
                            const _files = files
                                .map(f => {
                                    return {
                                        ...f,
                                        type: DocumentType.COPYOFDEED,
                                        uploaded: f.uploaded == undefined ? false : f.uploaded,
                                        isDeleted: f.isDeleted != undefined ? f.isDeleted : false
                                    };
                                });
                            _files.map(d => {
                                if (!d.uploaded) {
                                    saveDocument(d, d.type, state.values.sectionId);
                                }
                            });
                            handleChange(_files, 'documents');
                        }}
                        onRemove={(file) => {
                            const files = state.values.documents.filter(d => d.id === file.id);
                            deleteDocument(file.id, state.values.sectionId);
                            fieldActions.onChange(files, 'documents');
                        }}
                        heading='Upload Copy of Deed'
                    />
                </>
            )}
            {deedCount< 2 && !state.values.secgrantors && (
                <div className='mt-4 flex items-center'>
                    <button
                        className='rounded-full py-2 px-4 bg-primary-50 text-white text-sm font-medium focus:outline-none hover:bg-primary-60 flex items-center justify-between'
                        onClick={addDeed}
                    >
                        <MdAddCircle className='mr-2' size='1.25em' />
                        Add Another
                    </button>
                </div>
            )}
            {/* {deedOfTrustData} */}
            {

                (deedOfTustCountExceeded || state.values.dotmortgators) && (
                    <>
                        <header className='pt-2 pb-1 px-4 border-b flex items-center justify-between'>
                            <p className='font-semibold'>Deed of Trust</p>
                            {(
                                <button
                                    variant="outline-danger"
                                    className='rounded-full p-2 hover:bg-gray-150 focus:outline-none'
                                    style={{ color: "red" }}
                                    onClick={function() { removeDeedofTrust(); closeDeedTrustModal();  }}
                                >
                                    <MdClose />
                                </button>
                            )}
                        </header>
                        <TextArea
                            label='Mortgagor(s)'
                            readOnly={readonly}
                            groupClassName='col-span-12'
                            inputClassName='w-full border-1 border-gray-200 rounded bg-gray-50'
                            value={state.values.dotmortgators}
                            path='dotmortgators'
                            {...fieldActions}
                            onChange={handleChange}
                        />
                        <TextArea
                            label='Beneficiary'
                            readOnly={readonly}
                            groupClassName='col-span-12'
                            inputClassName='w-full border-1 border-gray-200 rounded bg-gray-50'
                            value={state.values.dotbeneficiary}
                            path='dotbeneficiary'
                            {...fieldActions}
                            onChange={handleChange}
                        />
                        <FormGroup
                            label='Trustee'
                            readOnly={readonly}
                            groupClassName='col-span-12'
                            inputClassName='w-full border-1 border-gray-200 rounded bg-gray-50'
                            value={state.values.dottrustee}
                            path='dottrustee'
                            {...fieldActions}
                            onChange={handleChange}
                        />
                        <div className="col-span-8 grid grid-cols-12 grid-flow-row gap-x-8 gap-y-4 text-sm mb-4">
                            <FormGroup
                                label='Securing Amount Of'
                                readOnly={readonly}
                                type='currency'
                                groupClassName='col-span-3'
                                inputClassName='w-full border-1 border-gray-200 rounded bg-gray-50'
                                value={state.values.dotsecuringAmountOf}
                                path='dotsecuringAmountOf'
                                {...fieldActions}
                                onChange={handleChange}
                            />
                            <FormGroup
                                label='Dated'
                                type='date-picker'
                                readOnly={readonly}
                                dateFormat="MM/dd/yyyy"
                                groupClassName='col-span-3'
                                inputClassName='w-full border-1 border-gray-200 rounded bg-gray-50'
                                datePickerClasses="w-full"
                                value={state.values.dotdated}
                                path='dotdated'
                                {...fieldActions}
                                onChange={handleChange}
                            />
                            <FormGroup
                                label='Recorded On'
                                type='date-picker'
                                readOnly={readonly}
                                dateFormat="MM/dd/yyyy   h:mm aa"
                                showTimeInput
                                timeInputLabel="Time:"
                                datePickerClasses="w-full"
                                groupClassName='col-span-6'
                                inputClassName='w-full border-1 border-gray-200 rounded bg-gray-50'
                                value={state.values.dotrecordedOn}
                                path='dotrecordedOn'
                                {...fieldActions}
                                onChange={handleChange}
                            />
                            <FormGroup
                                label='Book'
                                readOnly={readonly}
                                required={true}
                                groupClassName='col-span-3'
                                inputClassName='w-full border-1 border-gray-200 rounded bg-gray-50'
                                value={state.values.dotbook}
                                path='dotbook'
                                {...fieldActions}
                                onChange={handleChange}
                            />
                            <FormGroup
                                label='Page'
                                readOnly={readonly}
                                required
                                groupClassName='col-span-3'
                                inputClassName='w-full border-1 border-gray-200 rounded bg-gray-50'
                                value={state.values.dotpage}
                                path='dotpage'
                                {...fieldActions}
                                onChange={handleChange}
                            />
                            <FormGroup
                                label='County Registry'
                                readOnly={readonly}
                                required
                                groupClassName='col-span-3'
                                inputClassName='w-full border-1 border-gray-200 rounded bg-gray-50'
                                value={state.values.dotcountyRegistry}
                                path='dotcountyRegistry'
                                {...fieldActions}
                                onChange={handleChange}
                            />
                        </div>
                        <div className='col-span-12 border-b py-2' />
                        <div className="col-span-8 grid grid-cols-12 grid-flow-row gap-x-8 gap-y-4 text-sm mb-4">
                            <FormGroup
                                label='Re-recorded On (If Applicable)'
                                type='date-picker'
                                readOnly={readonly}
                                dateFormat="MM/dd/yyyy   h:mm aa"
                                showTimeInput
                                timeInputLabel="Time:"
                                datePickerClasses="w-full"
                                groupClassName='col-span-6'
                                inputClassName='w-full border-1 border-gray-200 rounded bg-gray-50'
                                value={state.values.dotreRecordedOn}
                                path='dotreRecordedOn'
                                {...fieldActions}
                                onChange={handleChange}
                            />
                            <FormGroup
                                label='Book'
                                readOnly={readonly}
                                groupClassName='col-span-3 col-start-1'
                                inputClassName='w-full border-1 border-gray-200 rounded bg-gray-50'
                                value={state.values.dotreBook}
                                path='dotreBook'
                                {...fieldActions}
                                onChange={handleChange}
                            />
                            <FormGroup
                                label='Page'
                                readOnly={readonly}
                                groupClassName='col-span-3'
                                inputClassName='w-full border-1 border-gray-200 rounded bg-gray-50'
                                value={state.values.dotrePage}
                                path='dotrePage'
                                {...fieldActions}
                                onChange={handleChange}
                            />
                            <FormGroup
                                label='County Registry'
                                readOnly={readonly}
                                groupClassName='col-span-3'
                                inputClassName='w-full border-1 border-gray-200 rounded bg-gray-50'
                                value={state.values.dotreCountyRegistry}
                                path='dotreCountyRegistry'
                                {...fieldActions}
                                onChange={handleChange}
                            />
                            <div className='col-span-12 border-b py-2' />
                            <FormGroup
                                label='Assigned To'
                                readOnly={readonly}
                                groupClassName='col-span-3'
                                inputClassName='w-full border-1 border-gray-200 rounded bg-gray-50'
                                value={state.values.dotassignedTo}
                                path='dotassignedTo'
                                {...fieldActions}
                                onChange={handleChange}
                            />
                            <FormGroup
                                label='Book'
                                readOnly={readonly}
                                groupClassName='col-span-3'
                                inputClassName='w-full border-1 border-gray-200 rounded bg-gray-50'
                                value={state.values.dotassignedBook}
                                path='dotassignedBook'
                                {...fieldActions}
                                onChange={handleChange}
                            />
                            <FormGroup
                                label='Page'
                                readOnly={readonly}
                                groupClassName='col-span-3'
                                inputClassName='w-full border-1 border-gray-200 rounded bg-gray-50'
                                value={state.values.dotassignedPage}
                                path='dotassignedPage'
                                {...fieldActions}
                                onChange={handleChange}
                            />
                            <FormGroup
                                label='County Registry'
                                readOnly={readonly}
                                groupClassName='col-span-3'
                                inputClassName='w-full border-1 border-gray-200 rounded bg-gray-50'
                                value={state.values.dotassignedCountyRegistry}
                                path='dotassignedCountyRegistry'
                                {...fieldActions}
                                onChange={handleChange}
                            />
                            <div className='col-span-12 flex items-center'>
                                <p className='mr-4'>The Deed of Trust identified above is a valid</p>
                                <FormSelect
                                    label=''
                                    readOnly={readonly}
                                    inputClassName='w-full border-1 border-gray-200 rounded bg-gray-50'
                                    groupClassName='w-40'
                                    value={state.values.lienOrder}
                                    path='lienOrder'
                                    options={state.values.lienOrderOptions}
                                    {...fieldActions}
                                    onChange={handleChange}
                                />
                                <p className='ml-4'>lien on the property.</p>
                            </div>
                        </div>
                        <FileDrop
                            files={state.values.documents?.filter(d => d.type === DocumentType.DEED_OF_TRUST && !d.isDeleted)}
                            className='w-full h-20'
                            groupClassName='col-span-12'
                            multiple
                            readOnly={readonly}
                            onChange={files => {
                                const _files = files
                                    .map(f => {
                                        return {
                                            ...f,
                                            type: DocumentType.DEED_OF_TRUST,
                                            uploaded: f.uploaded == undefined ? false : f.uploaded,
                                            isDeleted: f.isDeleted != undefined ? f.isDeleted : false
                                        };
                                    });
                                _files.map(d => {
                                    if (!d.uploaded) {
                                        saveDocument(d, d.type, state.values.sectionId);
                                    }
                                });
                                handleChange(_files, 'documents');
                            }}
                            onRemove={(file) => {
                                const files = state.values.documents.filter(d => d.id === file.id);
                                deleteDocument(file.id, state.values.sectionId);
                                fieldActions.onChange(files, 'documents');
                            }}
                            heading='Upload Copy of Deed of Trust'
                        />
                    </>
                )}
            {
                !deedOfTustCountExceeded && !state.values.dotmortgators && (
                    <div className='mt-4 flex items-center'>
                        <button
                            className='rounded-full py-2 px-4 bg-primary-50 text-white text-sm font-medium focus:outline-none hover:bg-primary-60 flex items-center justify-between'
                            onClick={addDeedOfTrust}
                        >
                            <MdAddCircle className='mr-2' size='1.25em' />
                            Add a Deed of Trust
                        </button>
                    </div>

                )
            }

        </>
    );
};

export default DeedsOfTrust;

const headerClassName = 'bg-gray-50 py-2 px-4 border-b text-left';
const props = {
    className: 'py-1 px-4 border-t text-xs text-neutral-70'
};

function Deeds({ details, className, onEdit, readonly = false, onDelete }) {
    const columns = [
        {
            title: 'Deeds',
            cell: ({ data }) => {
                return (
                    <>{`Deed of Trust #${data.index + 1}`}</>
                );
            },
            canSort: false,
            headerClassName,
            props
        },
        {
            headerClassName,
            props,
            key: 'actions',
            canSort: false,
            title: '',
            cell: ({ data }) => {

                return readonly
                    ? (
                        <span className="flex justify-end h-8">
                            <button className="focus:outline-none" onClick={() => onEdit(data)}>
                                <AiOutlineSearch />
                            </button>
                        </span>
                    ) :
                    (
                        <span className="flex justify-end h-8">
                            <button className="mr-5 focus:outline-none"
                                onClick={() => onEdit(data)}
                            >
                                <FaPencilAlt />
                            </button>
                            <button className="focus:outline-none"
                                onClick={() => onDelete(data.sectionDetailId)}>
                                <FaTrash />
                            </button>
                        </span>
                    );
            }
        }
    ];

    const deeds = Array.isArray(details)
        ? details.map((d, i) => ({ ...d, index: i }))
        : [];

    {
        return <Grid className={className} columns={columns} data={deeds} />;
    }
}